class QuestionGroup {
    constructor(question = {}) {
        this.header = question?.Header || ''
        this.questions = question?.Questions || []
    }
}

export default QuestionGroup;